<div (click)="select()"
     [class.correct]="correct"
     [class.highlight-hover]="selectable"
     [class.highlight]="selected"
     [class.incorrect]="incorrect"
     class="kt-cti-piece">
    <img class="kt-cti-piece__icon" src="{{piece.imageUrl}}"/>
</div>